import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

const PriceTypeRadio = ({
  value,
  name,
  label,
  isDisabled = false,
  onChange
}) => {
  const { register } = useFormContext();
  const registration = register(name);
  return (
    <Form.Check
      type="radio"
      label={label}
      value={value}
      className="ms-1"
      id={Math.random()}
      {...registration}
      onChange={(event) => {
        registration.onChange(event);
        onChange?.(event);
      }}
      disabled={isDisabled}
    />
  );
};
export default PriceTypeRadio;
